import { render, staticRenderFns } from "./ItemAthoringDialog.vue?vue&type=template&id=25a0075a&scoped=true"
import script from "./ItemAthoringDialog.vue?vue&type=script&lang=ts"
export * from "./ItemAthoringDialog.vue?vue&type=script&lang=ts"
import style0 from "./ItemAthoringDialog.vue?vue&type=style&index=0&id=25a0075a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25a0075a",
  null
  
)

export default component.exports